import { isAuthenticated } from '../utils/authHelper';
import React, { Fragment } from 'react'
import { createMuiTheme } from '@material-ui/core/styles'
import { MuiThemeProvider } from '@material-ui/core/styles'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import { viewFile, viewBlobFile } from './viewFileUtilFunction';
import { browserHistory } from 'react-router'
import userdata from '../config/jwt_token'
import Header from './Header'
import { isEmpty } from 'lodash'; 
import {
  approveRequest, approveCeFRequest, approveDeletingVendor,
  approveUpdatingVendor, rejectRequest, getUpdatedRequestDetails, approveDeactivatingVendor, approveActivatingVendor
} from '../utils/VendorApiUtils'
const theme = createMuiTheme({
  overrides: {
    MuiListItemText: {
      secondary: {
        textDecoration: 'line-through',
        color: 'red'
      }
    }
  }
});
class VendorPreview extends React.Component {
  constructor(props) {
    super(props)
    if (!isAuthenticated()) {
      browserHistory.push('/')
    }
    this.state = {
      data: {
        name: '',
        contact_person_name: '',
        address: '',
        city_name: '',
        state_name: '',
        contact_number: '',
        alternate_contact_number: '',
        email_id: '',
        payment_mode: '',
        beneficiary_name: '',
        bank_acc_number: '',
        ifsc_code: '',
        bank_name: '',
        cancel_cheque_upload_file: null,
        cancel_cheque_upload_file_name: '',
        gstn: '',
        gstn_verified: '',
        gst_verification_remarks: '',
        gstn_status: '',
        tds_liability: '',
        tds_liability_remarks: '',
        tds_slab: '',
        it_section_applicable: '',
        pancard_number: '',
        pancard_file: undefined,
        pancard_file_name: '',
        pancard_status: '',
        aadhar_number: '',
        aadhar_file: undefined,
        aadhar_file_name: '',
        company_category: '',
        contractual_terms: '',
        city_finance_remarks: '',
        msme_vendor: '',
        msme_certificate_file: null,
        msme_certificate_file_name: '',
        agreement_expiry_date: '',
        vendor_agreement: '',
        vendor_agreement_file: null,
        vendor_agreement_file_name: '',
        msme_certificate: '',
        ldc_agreement_start_date: '',
        ldc_agreement_end_date: '',
        vendor_ldc_agreement: '',
        vendor_ldc_agreement_file: null,
        vendor_ldc_agreement_file_name: '',
        ldc_tds_rate_data: []
      },
      updatedData: {},
      approveDialogBox: false,
      central_finance_remarks: '',
      central_finance_remarksErr: false,
      central_finance_remarksErrText: '',
      status: '',
      approveddialogBoxText: '',
      isApprove: false,
      dialogBox: false,
      dialogBoxText: '',
    }
  }
  componentDidMount(props) {
    if (!isAuthenticated()) {
      browserHistory.push('/')
      return
    }
    if (userdata.role.indexOf('Central Finance') === -1 && userdata.role !== 'root' && userdata.role !== 'Vendor Approver L2') {
      browserHistory.push('/home')
    }
    if (this.props.location && this.props.location.state !== undefined) {
      if (this.props.location.state.transaction_type === 'vendor_update_request') {
        getUpdatedRequestDetails(JSON.stringify({ 'vendor_buffer_id': this.props.location.state.source_vendor_buffer_id }))
          .then((response) => {
            if (response) {
              if (response.status === 'success') {
                if(response.data && response.data.agreement_expiry_date) {
                  response.data.agreement_expiry_date = new Date(response.data.agreement_expiry_date)
                }
                if(response.data && response.data.ldc_agreement_start_date) {
                  response.data.ldc_agreement_start_date = new Date(response.data.ldc_agreement_start_date)
                }
                if(response.data && response.data.ldc_agreement_end_date) {
                  response.data.ldc_agreement_end_date = new Date(response.data.ldc_agreement_end_date)
                }
                let vendorData = {
                  ...response.data, ...response.data.acc_details[0], ...response.data.addresses[0], city_name: response.data.addresses[0].city_details.city_name
                  , state_name: response.data.addresses[0].city_details.state_details.state_name
                }
                delete vendorData.vendors
                delete vendorData.acc_details
                delete vendorData.addresses
                this.setState({ updatedData: vendorData })
              }
              else if (response.status === 'failure') {
                this.setState({ dialogBox: true, dialogBoxText: response.message })
              }
            }
          })
        this.setState({ 
          data: { 
            ...this.props.location.state,
            agreement_expiry_date: typeof this.props.location.state.agreement_expiry_date == 'string' ? new Date(this.props.location.state.agreement_expiry_date) : this.props.location.state.agreement_expiry_date,
            ldc_agreement_start_date: typeof this.props.location.state.ldc_agreement_start_date == 'string' ? new Date(this.props.location.state.ldc_agreement_start_date) : this.props.location.state.ldc_agreement_start_date,
            ldc_agreement_end_date: typeof this.props.location.state.ldc_agreement_end_date == 'string' ? new Date(this.props.location.state.ldc_agreement_end_date) : this.props.location.state.ldc_agreement_end_date
          } 
        })
      }
      else {
        this.setState({
          data: { 
            ...this.props.location.state,
            agreement_expiry_date: typeof this.props.location.state.agreement_expiry_date == 'string' ? new Date(this.props.location.state.agreement_expiry_date) : this.props.location.state.agreement_expiry_date,
            ldc_agreement_start_date: typeof this.props.location.state.ldc_agreement_start_date == 'string' ? new Date(this.props.location.state.ldc_agreement_start_date) : this.props.location.state.ldc_agreement_start_date,
            ldc_agreement_end_date: typeof this.props.location.state.ldc_agreement_end_date == 'string' ? new Date(this.props.location.state.ldc_agreement_end_date) : this.props.location.state.ldc_agreement_end_date
          }
        })
      }

    }
  }
  handleChange(event) {
    this.setState({ central_finance_remarks: event.target.value, central_finance_remarksErr: false, central_finance_remarksErrText: '' })
  }
  handleDialogBox(value) {
    if (!this.state.central_finance_remarks) {
      this.setState({ central_finance_remarksErr: true, central_finance_remarksErrText: 'comment is required' })
      return
    }
    if (value === 'approve') {
      this.setState({ approveddialogBoxText: 'Are you sure,you want to approve this request', approveDialogBox: true, isApprove: true })
    }
    else {
      this.setState({ approveddialogBoxText: 'Are you sure,you want to reject this request', approveDialogBox: true })
    }
  }
  async handleApprove() {
    let response
    let body = {
      'transaction_id': this.state.data.transaction_id, 'vendor_buffer_id': this.state.data.vendor_buffer_id,
    };
    body = userdata.role === 'Vendor Approver L2'?{...body, 'vendor_approver_l2_remarks': this.state.central_finance_remarks}:{...body, 'central_finance_remarks': this.state.central_finance_remarks}
    body = JSON.stringify(body);
    switch (true) {
      case (this.state.data.transaction_type === 'onboard_request'):
        if (this.state.data.status === 'approved_by_central_finance') {
          response = await approveRequest(body)
        } else {
          response = await approveCeFRequest(body)
        }
        break;
      case (this.state.data.transaction_type === 'delete_approved_vendor'):
        response = await approveDeletingVendor(body)
        break;
      case (this.state.data.transaction_type === 'deactivate_approved_vendor'):
        response = await approveDeactivatingVendor(body)
        break;
      case (this.state.data.transaction_type === 'activate_approved_vendor'):
        response = await approveActivatingVendor(body)
        break;
      case (this.state.data.transaction_type === 'vendor_update_request'):
        response = await approveUpdatingVendor(body)
        break;
      // when the CeF rejects a vendor due to faulty bank details
      case (this.state.data.transaction_type === 'rejected_by_bank'):
        response = await approveUpdatingVendor(body)
        break;
      case (this.state.data.transaction_type === 'update_rejected_request'):
        if (this.state.data.status === 'approved_by_central_finance') {
          response = await approveRequest(body)
        } else {
          response = await approveCeFRequest(body)
        }
      default:
        break
    }
    if (response) {
      if (response.status === 'success') {
        this.setState({ dialogBox: true, dialogBoxText: response.message, approveDialogBox: false, approveddialogBoxText: '' })
      }
      else if (response.status === 'failure') {
        this.setState({ dialogBox: true, dialogBoxText: response.message })
      }
    }
  }
  handleFileDialogClose = () => {
    this.setState({ openFileDialog: false });
  };
  handleReject() {
    rejectRequest(JSON.stringify({ 'transaction_id': this.state.data.transaction_id, 'central_finance_remarks': this.state.central_finance_remarks })).then((response) => {
      if (response) {
        if (response.status === 'success') {
          this.setState({ dialogBox: true, dialogBoxText: 'Rejected Successfully', approveDialogBox: false, approveddialogBoxText: '' })
        }
        else if (response.status === 'failure') {
          this.setState({ dialogBox: true, dialogBoxText: response.message })
        }
      }
    })
  }
  handleClose() {
    browserHistory.push('/vendor/approval')
  }
  handleNo() {
    this.setState({ approveDialogBox: false, approveddialogBoxText: '' })
  }
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Header />
        <div style={{ marginTop: '20px', textAlign: 'center', display: 'flex', justifyContent: 'center', marginBottom: '40px' }}>
          <Paper style={{ width: '700px', height: 'auto' }} elevation={1}>
            <Grid item xs={12} md={6} style={{ marginLeft: '94px' }}>

              <List >
                <ListItem >

                  <ListItemText style={{ minWidth: '240px' }} primary=" Vendor name" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.name}
                    secondary={this.state.data.name !== this.state.updatedData.name ? this.state.updatedData.name : null} />
                </ListItem>
                <ListItem>

                  <ListItemText style={{ minWidth: '240px' }} primary=" Contact Person Name" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.contact_person_name}
                    secondary={this.state.data.contact_person_name !== this.state.updatedData.contact_person_name ? this.state.updatedData.contact_person_name : null} />
                </ListItem>
                <ListItem>

                  <ListItemText style={{ minWidth: '240px' }} primary="Vendor Address " />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.address}
                    secondary={this.state.data.address !== this.state.updatedData.address ? this.state.updatedData.address : null} />
                </ListItem>
                <ListItem>

                  <ListItemText style={{ minWidth: '240px' }} primary=" Vendor City" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.city_name}
                    secondary={this.state.data.city_name !== this.state.updatedData.city_name ? this.state.updatedData.city_name : null} />
                </ListItem>
                <ListItem>

                  <ListItemText style={{ minWidth: '240px' }} primary=" Vendor State" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.state_name}
                    secondary={this.state.data.state_name !== this.state.updatedData.state_name ? this.state.updatedData.state_name : null} />
                </ListItem>
                <ListItem>

                  <ListItemText style={{ minWidth: '240px' }} primary=" National" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.national?'Yes':'No'}
                    secondary={(!isEmpty(this.state.updatedData) && this.state.data.national !== this.state.updatedData.national) ? this.state.updatedData.national?'Yes':'No': null } />
                </ListItem>
                <ListItem>

                  <ListItemText style={{ minWidth: '240px' }} primary=" Contact Number" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.contact_number}
                    secondary={this.state.data.contact_number !== this.state.updatedData.contact_number ? this.state.updatedData.contact_number : null} />
                </ListItem>
                {this.state.data.alternate_contact_number && <ListItem>

                  <ListItemText style={{ minWidth: '240px' }} primary="Alternate Contact Number" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.alternate_contact_number}
                    secondary={this.state.data.alternate_contact_number !== this.state.updatedData.alternate_contact_number ? this.state.updatedData.alternate_contact_number : null} />
                </ListItem>}
                <ListItem>

                  <ListItemText style={{ minWidth: '240px' }} primary="Email Id" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.email_id}
                    secondary={this.state.data.email_id !== this.state.updatedData.email_id ? this.state.updatedData.email_id : null} />
                </ListItem>
                <ListItem>

                  <ListItemText style={{ minWidth: '240px' }} primary="Payment Mode" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.payment_mode}
                    secondary={this.state.data.payment_mode !== this.state.updatedData.payment_mode ? this.state.updatedData.payment_mode : null} />
                </ListItem>
                {this.state.data.payment_mode === 'online payment' && <div>
                <ListItem>
                <ListItemText style={{ minWidth: '240px' }} primary="Trade licence file" />
                <ListItemText style={{ minWidth: '10px' }} primary=":" />
                {
                  ((this.state.data.trade_licence_file !== null && this.state.data.trade_licence_file !== "") || this.state.data.trade_licence_file_name !== "") ?
                  (typeof(this.state.data.trade_licence_file) !== 'string') ?
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewBlobFile(this.state.data.trade_licence_file)}>View</Button>}/>:
                  <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.trade_licence_file)}>View</Button>} />
                  :
                  <ListItemText style={{ minWidth: '240px' }} primary="N.A" />
                }
                </ListItem>
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="Beneficiary Name" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.beneficiary_name}
                    secondary={this.state.data.beneficiary_name !== this.state.updatedData.beneficiary_name ? this.state.updatedData.beneficiary_name : null} />
                </ListItem>
                  <ListItem>

                    <ListItemText style={{ minWidth: '240px' }} primary="Bank Account Number" />
                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                    <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.bank_acc_number}
                      secondary={this.state.data.bank_acc_number !== this.state.updatedData.bank_acc_number ? this.state.updatedData.bank_acc_number : null} />
                  </ListItem>
                  <ListItem>
                    <ListItemText style={{ minWidth: '240px' }} primary="IFSC Code" />
                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                    <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.ifsc_code}
                      secondary={this.state.data.ifsc_code !== this.state.updatedData.ifsc_code ? this.state.updatedData.ifsc_code : null} />
                  </ListItem>
                  <ListItem>
                    <ListItemText style={{ minWidth: '240px' }} primary="Bank Name" />
                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                    <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.bank_name}
                      secondary={this.state.data.bank_name !== this.state.updatedData.bank_name ? this.state.updatedData.bank_name : null} />
                  </ListItem>
                  {this.state.data.cancel_cheque_upload_file_name !== '' && this.state.data.cancel_cheque_upload_file &&
                    <ListItem>
                      <ListItemText style={{ minWidth: '240px' }} primary="Cancel Cheque Copy" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      {/* <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.cancel_cheque_upload_file}
                        secondary={this.state.data.cancel_cheque_upload_file !== this.state.updatedData.cancel_cheque_upload_file ? this.state.updatedData.cancel_cheque_upload_file : null} /> */}
                      <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.cancel_cheque_upload_file)}>View</Button>} />
                    </ListItem>}</div>}
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="Vendor Agreement" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.vendor_agreement && this.state.data.vendor_agreement.toString() === '1' ? 'Yes' : 'No'} secondary={this.state.data.vendor_agreement != this.state.updatedData.vendor_agreement ? this.state.updatedData.vendor_agreement && this.state.updatedData.vendor_agreement.toString()  === '1' ? 'Yes' : 'No' : null } />
                </ListItem>
                {this.state.data.vendor_agreement && this.state.data.vendor_agreement.toString() === '1' ? (
                  <Fragment>
                    <ListItem>
                      <ListItemText style={{ minWidth: '240px' }} primary="Agreement Expiry Date" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      <ListItemText 
                        style={{ minWidth: '240px' }} 
                        primary={this.state.data.agreement_expiry_date && this.state.data.agreement_expiry_date.toDateString()}
                        secondary={this.state.data.agreement_expiry_date !== this.state.updatedData.agreement_expiry_date ? this.state.updatedData.agreement_expiry_date && this.state.updatedData.agreement_expiry_date.toDateString() : null}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText style={{ minWidth: '240px' }} primary="Vendor Agreement File" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      {
                        (this.state.data.vendor_agreement && this.state.data.vendor_agreement.toString() === '1') ?
                          (typeof(this.state.data.vendor_agreement_file) !== 'string' && this.state.data.vendor_agreement_file !== undefined) ?
                            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewBlobFile(this.state.data.vendor_agreement_file)}>View</Button>}/>:
                            <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.vendor_agreement_file_name)}>View</Button>} />
                          :
                          <ListItemText style={{ minWidth: '240px' }} primary="N.A" />
                      }
                    </ListItem>
                  </Fragment>
                ) : null}
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="Vendor Defaulted Amount" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.defaultor_amount}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="Vendor LDC Agreement" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.vendor_ldc_agreement && this.state.data.vendor_ldc_agreement.toString() === '1' ? 'Yes' : 'No'} secondary={this.state.data.vendor_ldc_agreement != this.state.updatedData.vendor_ldc_agreement ? this.state.updatedData.vendor_ldc_agreement && this.state.updatedData.vendor_ldc_agreement.toString()  === '1' ? 'Yes' : 'No' : null } />
                </ListItem>
                {this.state.data.vendor_ldc_agreement && this.state.data.vendor_ldc_agreement.toString() === '1' ? (
                  <Fragment>
                    <ListItem>
                      <ListItemText style={{ minWidth: '240px' }} primary="LDC Agreement Start Date" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      <ListItemText 
                        style={{ minWidth: '240px' }} 
                        primary={this.state.data.ldc_agreement_start_date && this.state.data.ldc_agreement_start_date.toDateString()}
                        secondary={this.state.data.ldc_agreement_start_date !== this.state.updatedData.ldc_agreement_start_date ? this.state.updatedData.ldc_agreement_start_date && this.state.updatedData.ldc_agreement_start_date.toDateString() : null}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText style={{ minWidth: '240px' }} primary="LDC Agreement End Date" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      <ListItemText 
                        style={{ minWidth: '240px' }} 
                        primary={this.state.data.ldc_agreement_end_date && this.state.data.ldc_agreement_end_date.toDateString()}
                        secondary={this.state.data.ldc_agreement_end_date !== this.state.updatedData.ldc_agreement_end_date ? this.state.updatedData.ldc_agreement_end_date && this.state.updatedData.ldc_agreement_end_date.toDateString() : null}
                      />
                    </ListItem>
                    {/* <ListItem>
                      <ListItemText style={{ minWidth: '240px' }} primary="LDC Amount Limit" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.ldc_amount_limit} secondary={this.state.data.ldc_amount_limit !== this.state.updatedData.ldc_amount_limit ? this.state.updatedData.ldc_amount_limit : null}
                      />
                    </ListItem> */}
                    {this.state.data.ldc_tds_rate_data && this.state.data.ldc_tds_rate_data.map((data, index) => (
                      <ListItem key={index}>
                        <ListItemText style={{ minWidth: '240px' }} primary={data.tds_section_name || 'TDS Section'} />
                        <ListItemText style={{ minWidth: '10px' }} primary=":" />
                        <ListItemText 
                          style={{ minWidth: '240px', wordWrap: 'break-word' }} 
                          primary={
                            <div>
                              <span>{`LDC Limit: \u20B9 ${data.ldc_amount_limit}`}</span><br/>
                              <span>LDC Rate: {data.ldc_rate}</span>
                            </div>
                          }
                        />
                      </ListItem>
                    ))}
                    <ListItem>
                      <ListItemText style={{ minWidth: '240px' }} primary="Vendor LDC Agreement File" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      {
                        (this.state.data.vendor_ldc_agreement && this.state.data.vendor_ldc_agreement.toString() === '1') ?
                          (typeof(this.state.data.vendor_ldc_agreement_file) !== 'string' && this.state.data.vendor_ldc_agreement_file !== undefined) ?
                            <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewBlobFile(this.state.data.vendor_ldc_agreement_file)}>View</Button>}/>:
                            <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.vendor_ldc_agreement_file_name)}>View</Button>} />
                          :
                          <ListItemText style={{ minWidth: '240px' }} primary="N.A" />
                      }
                    </ListItem>
                  </Fragment>
                ) : null}
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="MSME Vendor" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={(this.state.data.msme_vendor !== null && this.state.data.msme_vendor.toString() === '1')?'Yes':'No'} />
                </ListItem>
                {this.state.data.msme_vendor !== null && this.state.data.msme_vendor.toString() === '1'
                && <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="MSME Certificate File Name" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  {
                    (this.state.data.msme_vendor.toString() === '1') ?
                      (typeof(this.state.data.msme_certificate_file) !== 'string' && this.state.data.msme_certificate_file !== undefined) ?
                        <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewBlobFile(this.state.data.msme_certificate_file)}>View</Button>}/>:
                        <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.msme_certificate)}>View</Button>} />
                      :
                      <ListItemText style={{ minWidth: '240px' }} primary="N.A" />
                  }
                </ListItem>}
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="GST Number" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.gstn}
                    secondary={this.state.data.gstn !== this.state.updatedData.gstn ? this.state.updatedData.gstn : null} />
                </ListItem>
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="GST Status" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.gstn_status}
                    secondary={this.state.data.gstn_status !== this.state.updatedData.gstn_status ? this.state.updatedData.gstn_status : null} />
                </ListItem>
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="GST Verified" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.gstn_verified}
                    secondary={this.state.data.gstn_verified !== this.state.updatedData.gstn_verified ? this.state.updatedData.gstn_verified : null} />
                </ListItem>
                {this.state.data.gstn_verified !== 'yes' ? <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="GST Verification Remarks" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.gstn_verification_remarks}
                  />
                </ListItem> : <div> <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="Legal Name" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.legal_name}
                  />
                </ListItem> <ListItem>
                      <ListItemText style={{ minWidth: '240px' }} primary="Entity Type" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.entity_type}
                      />
                    </ListItem> <ListItem>
                      <ListItemText style={{ minWidth: '240px' }} primary="Registration Type" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.registration_type}
                      />
                    </ListItem> <ListItem>
                      <ListItemText style={{ minWidth: '240px' }} primary="Department Code" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.department_code}
                      />
                    </ListItem> <ListItem>
                      <ListItemText style={{ minWidth: '240px' }} primary="Nature Of Business" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.nature_of_business}
                      />
                    </ListItem> <ListItem>
                      <ListItemText style={{ minWidth: '240px' }} primary="Registration Date" />
                      <ListItemText style={{ minWidth: '10px' }} primary=":" />
                      <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.registration_date}
                      />
                    </ListItem></div>}
                {this.state.data.tds_liability !== '' && this.state.data.tds_liability && <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="TDS Liability" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.tds_liability}
                    secondary={this.state.data.tds_liability !== this.state.updatedData.tds_liability ? this.state.updatedData.tds_liability : null} />
                </ListItem>}
                {this.state.data.tds_liability_remarks !== '' && this.state.data.tds_liability_remarks
                  && <ListItem>
                    <ListItemText style={{ minWidth: '240px' }} primary="TDS Liablity Remarks" />
                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                    <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.tds_liability_remarks}
                      secondary={this.state.data.tds_liability_remarks !== this.state.updatedData.tds_liability_remarks ? this.state.updatedData.tds_liability_remarks : null} />
                  </ListItem>}
                {this.state.data.tds_liability === 'yes' && this.state.data.pancard_number !== '' && this.state.data.pancard_number
                  && <ListItem>
                    <ListItemText style={{ minWidth: '240px' }} primary="Pan Number" />
                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                    <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.pancard_number}
                      secondary={this.state.data.pancard_number !== this.state.updatedData.pancard_number ? this.state.updatedData.pancard_number : null} />
                  </ListItem>}
                {this.state.data.tds_liability === 'yes' && this.state.data.pancard_scan_copy !== '' && this.state.data.pancard_scan_copy
                  && <ListItem>
                    <ListItemText style={{ minWidth: '240px' }} primary="Pan Number File Name" />
                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                    {/* <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.pancard_scan_copy}
                      secondary={this.state.data.pancard_scan_copy !== this.state.updatedData.pancard_scan_copy ? this.state.updatedData.pancard_scan_copy : null} /> */}
                      <ListItemText style={{ minWidth: '240px' }} primary={ <Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.pancard_scan_copy)}>View</Button> } />
                  </ListItem>}
                  {this.state.data.tds_liability === 'yes'
                  && <ListItem>
                    <ListItemText style={{ minWidth: '240px' }} primary="Pan Status" />
                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                    <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.pancard_status == '0' ? 'Inoperative' : 'Operative'}
                    secondary={(!isEmpty(this.state.updatedData) && this.state.data.pancard_status !== this.state.updatedData.pancard_status) ? (this.state.updatedData.pancard_status == "0" ? "Inoperative" : "Operative"): null }
                    />
                  </ListItem>}
                  {this.state.data.tds_liability === 'yes' && this.state.data.aadhar_number !== '' && this.state.data.aadhar_number
                  && <ListItem>
                    <ListItemText style={{ minWidth: '240px' }} primary="Aadhaar Number" />
                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                    <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={this.state.data.aadhar_number}
                    />
                  </ListItem>}
                  {this.state.data.tds_liability === 'yes' && ((this.state.data.aadhar_scan_copy !== '' && this.state.data.aadhar_scan_copy) || (this.state.data.aadhar_file_name !== '' && this.state.data.aadhar_file_name))
                  && <ListItem>
                    <ListItemText style={{ minWidth: '240px' }} primary="Aadhaar Number File Name" />
                    <ListItemText style={{ minWidth: '10px' }} primary=":" />
                    {
                      (this.state.data.aadhar_file !== undefined)?
                      <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewBlobFile(this.state.data.aadhar_file)}>View</Button>} />:
                      null
                    }
                    { (this.state.data.aadhar_file === undefined)?
                      (this.state.data.aadhar_file_name)?
                      <ListItemText style={{ minWidth: '240px' }} primary={<Button style={{'backgroundColor':'rgb(0,188,212)','width':'50px','height':'20px','color':'white'}} onClick={()=>viewFile(this.state.data.aadhar_file_name)}>View</Button>} />:null
                      :null
                    }
                  </ListItem>}
                {this.state.data.company_category && <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="Company Category" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.company_category}
                    secondary={this.state.data.company_category !== this.state.updatedData.company_category ? this.state.updatedData.company_category : null} />
                </ListItem>}
                {this.state.data.contractual_terms && <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="Contractual Terms" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.contractual_terms}
                    secondary={this.state.data.contractual_terms !== this.state.updatedData.contractual_terms ? this.state.updatedData.contractual_terms : null} />
                </ListItem>}
                <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="City Finance Comment" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.city_finance_remarks} />
                </ListItem>
                {this.state.data.central_finance_remarks && <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="Central Finance Comment" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.central_finance_remarks} />
                </ListItem>}
                {this.state.data.vendor_approver_l2_remarks && <ListItem>
                  <ListItemText style={{ minWidth: '240px' }} primary="Vendor Approver L2 Comment" />
                  <ListItemText style={{ minWidth: '10px' }} primary=":" />
                  <ListItemText style={{ minWidth: '240px' }} primary={this.state.data.vendor_approver_l2_remarks} />
                </ListItem>}
              </List>
            </Grid>
            {(this.state.data.status === 'pending' || this.state.data.status === 'approved_by_central_finance') && <div> <TextField
              label="Comment"
              placeholder="Enter Comment"
              value={this.state.central_finance_remarks}
              onChange={this.handleChange.bind(this)}
              style={{ width: '520px', marginBottom: '20px' }}
              error={this.state.central_finance_remarksErr}
              helperText={this.state.central_finance_remarksErrText} />
              <div>
                <Button variant="contained" size="large" style={{backgroundColor: 'rgb(121,183,79)',color: 'white', marginTop: '30px', marginBottom: '30px' }} onClick={this.handleDialogBox.bind(this, 'approve')}>
                  Approve
               </Button>
                <Button variant="contained" size="large" style={{backgroundColor: 'rgb(220,20,60)',color: 'white', marginTop: '30px', marginLeft: '12px', marginBottom: '30px' }} onClick={this.handleDialogBox.bind(this, 'reject')}>
                  Reject
               </Button>
              </div></div>}
          </Paper>
        </div>
        <Dialog
          modal={false}
          open={this.state.dialogBox}
          onClose={this.handleClose.bind(this)}
          aria-labelledby="alert-dialog-title1"
          aria-describedby="alert-dialog-description1"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description1">
              <h4 style={{ textAlign: 'center' }}>{this.state.dialogBoxText}</h4>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button primary={true} onClick={this.handleClose.bind(this)} >OK</Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.approveDialogBox}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.approveddialogBoxText}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleNo.bind(this)} color="primary">
              No
            </Button>
            <Button onClick={this.state.isApprove === true ? this.handleApprove.bind(this) : this.handleReject.bind(this)} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>

      </MuiThemeProvider>
    )
  }
}
export default VendorPreview


// WEBPACK FOOTER //
// ./src/components/VendorApproval.js